import CombinedStorage from 'Utils/storage/CombinedStorage';
import EncryptedStorage from 'Utils/storage/EncryptedStorage';
import NativeStorage from 'Utils/storage/NativeStorage';
export default class FormValuesMigrator {
    /**
     * Remove every PRE-namespacing draft key (the shared, un-namespaced keys written before UNIV-3405).
     * Runs on every load, before the storage managers read their now-namespaced keys.
     *
     * We DELETE these keys — we never adopt them into a namespace. An un-namespaced key can't be attributed
     * to any account, so copying it into the current account's namespace would let the next user inherit a
     * stranger's draft (the UNIV-3404 leak). A logged-in user's own resume is namespaced and server-synced,
     * so nothing of value is lost; deleting is what guarantees cross-account isolation here, without relying
     * on the RN app's logout clear (which UNIV-3404 removes).
     */
    static async migrateToAccountNamespace() {
        const storage = CombinedStorage.instance();
        const legacyKeys = [
            'rirekisho_multistep_values', // v0
            'rirekisho_multistep_values_v1', // v1
            'rirekisho_print_history'
        ];
        for (const baseKey of legacyKeys) {
            // eslint-disable-next-line no-await-in-loop
            await storage.removeItem(baseKey);
        }
    }
    static async migrateDataFromLocalToNativeStorage() {
        const IS_MIGRATED_TO_NATIVE_STORAGE = 'rirekisho_native_storage_migrated';
        if (localStorage.getItem(IS_MIGRATED_TO_NATIVE_STORAGE) === '1') {
            return;
        }
        const nativeAvailable = await NativeStorage.instance().isAvailable();
        const encryptAvailable = await EncryptedStorage.instance().isAvailable();
        const migrateKeys = [
            'rirekisho_multistep_values',
            'rirekisho_multistep_values_v1',
            'rirekisho_print_history'
        ];
        if (nativeAvailable && encryptAvailable) {
            for (let i = migrateKeys.length - 1; i >= 0; i--) {
                const key = migrateKeys[i];
                const values = await NativeStorage.instance().getItem(key);
                const oldValues = await EncryptedStorage.instance().getItem(key);
                if (values === null && oldValues !== null) {
                    await NativeStorage.instance().setItem(key, oldValues);
                }
            }
            localStorage.setItem(IS_MIGRATED_TO_NATIVE_STORAGE, '1');
        }
    }
}
